<mat-progress-bar *ngIf="isLoading" [color]="'grey'" [mode]="'indeterminate'">
</mat-progress-bar>
